<template>
  <section class="ls-radio-buttons--space-between">
    <BField
      :label="label"
      :type="{ 'is-error': getValidation.invalid }"
      :message="getValidation.message"
      class="ls-radio-buttons--label"
    />

    <BField class="ls-radio-buttons--buttons">
      <BRadioButton
        v-for="(option, idx) in options"
        :key="option.label"
        v-model="localValue"
        v-validate="validation"
        :name="name"
        :native-value="option.value"
        :disabled="option.disabled || disabled"
        :test-id="testIds[idx]"
        size="is-medium"
        >{{ option.label }}</BRadioButton
      >
    </BField>
  </section>
</template>

<script>
import { lsPropTypeHelpers, lsTrackingService, lsValidationService } from 'ls-vue-common';
import VueTypes from 'vue-types';
import _ from 'lodash';

export default {
  name: 'LsRadioButtons',
  inject: ['$validator'],
  props: {
    value: VueTypes.any.isRequired,
    trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
    name: VueTypes.string.isRequired,
    options: VueTypes.arrayOf(
      VueTypes.shape({
        label: VueTypes.string.isRequired,
        value: VueTypes.any.isRequired,
        disabled: VueTypes.bool,
      })
    ).isRequired,
    label: VueTypes.string,
    validation: VueTypes.object.def(_.constant(null)),
    disabled: VueTypes.bool.def(false),
    testId: VueTypes.string,
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        lsTrackingService.track({
          event: 'click',
          target: this.trackId,
          data: { value },
        });
        this.$emit('input', value);
      },
    },
    getValidation() {
      return lsValidationService.getValidation.call(this);
    },
    testIds() {
      return _.map(this.options, ({ label }) => {
        return `${this.testId}-${_.snakeCase(label)}`;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-radio-buttons--space-between {
  display: flex;
}

.ls-radio-buttons--label {
  margin: 5px 15px 0 0;
  flex-shrink: 100;
}

.ls-radio-buttons--buttons {
  margin-left: auto;
}
</style>
